export default __webpack_public_path__ + "images/6aeef4af9a6c4901da865b6df5de075c-arts.jpg";